<template>
  <InfoDropdown title="Members" class="-right-15 top-45 relative" @show-dropdown="showDropdown">
    <div class="pb-8 px-12 overflow-y-auto">
      <div v-for="(user, index) in members" :key="index" class="mb-4 text-15 flex items-center w-full">
        <span class="w-3 rounded-2 h-21 mr-10 block" :style="getColor(user.color)" />
        <div class="flex items-center justify-between w-full">
          <p>{{ user.firstName }}</p>
        </div>
      </div>
    </div>
  </InfoDropdown>
</template>

<script>
import InfoDropdown from '@/components/shared/InfoDropdown'
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import userColorMixin from '@/mixins/userColorMixin'
import { teamsService } from '@/services'

export default defineComponent({
  components: { InfoDropdown },

  props: {
    members: Array,
    bookId: Number
  },

  emits: ['openModal', 'showDropdown'],

  setup (props, { emit }) {
    const { getters, state, dispatch } = useStore()

    const { getColor } = userColorMixin()

    const currentMember = computed(() => state.team.member)
    const isDarkMode = computed(() => getters.isDarkMode)

    function openModal () {
      emit('openModal')
    }

    function showDropdown () {
      emit('showDropdown')
    }

    function deleteMember (id) {
      teamsService.removeMemberFromSpace({
        memberId: id,
        bookId: props.bookId
      })
        .then(() => dispatch('getBooks'))
    }

    return {
      currentMember,
      isDarkMode,
      // functions
      getColor,
      openModal,
      showDropdown,
      deleteMember
    }
  }
})
</script>
